<template>
  <div class="with-side-panel">
    <div class="content-i">
      <div class="content-box">
        <div class="element-wrapper">
          <h6 class="element-header">
            {{ $t('dashboard.dashboard_for') + piniaUserStore().currentUser?.user?.userAccessRightsTranslation }}
          </h6>

          <Menu/>

          <div class="element-box mt-4">
            <div class="row mt-2">
              <!-- 1. Soziotherapie -->
              <CoachingButton
                  :enabled="companySettings?.socioTherapyCoachingEnabled"
                  route-name="socioTherapyCoachingNewAndActiveList"
                  icon="fa-hand-holding-heart"
                  coaching-type="socioTherapy"
                  label="Soziotherapie"/>

              <!-- 2. Betreutes Wohnen -->
              <CoachingButton
                  :enabled="companySettings?.assistedLivingCoachingEnabled"
                  route-name="assistedLivingCoachingNewAndActiveList"
                  icon="fa-house-chimney-user"
                  coaching-type="assistedLiving"
                  label="Betreutes Wohnen"/>
            </div>
          </div>

          <div class="row mt-5">
            <!-- Aktive Kunden -->
            <div class="col-lg-6 col-sm-12">
              <h6 class="mb-3">{{ $t('general.active_customers') }}</h6>
              <div class="row g-4">
                <!-- 1. Soziotherapie -->
                <div class="col-md-6 col-sm-12"
                     v-if="companySettings?.socioTherapyCoachingEnabled">
                  <CoachingCardInfo
                      label="Soziotherapie"
                      type="socioTherapy"
                      :value="dashboardData?.countActiveCoaching?.counts?.socioTherapyCoaching"
                  />
                </div>

                <!-- 2. Betreutes Wohnen -->
                <div class="col-md-6 col-sm-12"
                     v-if="companySettings?.assistedLivingCoachingEnabled">
                  <CoachingCardInfo
                      label="Betreutes Wohnen"
                      type="assistedLiving"
                      :value="dashboardData?.countActiveCoaching?.counts?.assistedLivingCoaching"
                  />
                </div>
              </div>
            </div>

            <!-- Neue Kunden -->
            <div class="col-lg-6 col-sm-12">
              <h6 class="mb-3">{{ $t('general.new_customers') }}</h6>
              <div class="row g-4">
                <!-- 1. Soziotherapie -->
                <div class="col-md-6 col-sm-12"
                     v-if="companySettings?.socioTherapyCoachingEnabled">
                  <CoachingCardInfo
                      label="Soziotherapie"
                      type="socioTherapy"
                      :value="dashboardData?.countNewCoaching?.counts?.socioTherapyCoaching"
                  />
                </div>

                <!-- 2. Betreutes Wohnen -->
                <div class="col-md-6 col-sm-12"
                     v-if="companySettings?.assistedLivingCoachingEnabled">
                  <CoachingCardInfo
                      label="Betreutes Wohnen"
                      type="assistedLiving"
                      :value="dashboardData?.countNewCoaching?.counts?.assistedLivingCoaching"
                  />
                </div>
              </div>
            </div>
          </div>

          <div v-if="companySettings?.assistedLivingCoachingEnabled" class="mt-4">
            <h6 class="section-subtitle mb-3">
              Betreutes Wohnen
            </h6>

            <div class="row g-4">
              <!-- Summe FLS pro Woche -->
              <div class="col-lg-3 col-md-6 col-sm-12">
                <CoachingCardInfo
                    label="Summe FLS pro Woche"
                    type="weeklySum"
                    :value="dashboardData?.sumUnitsInWeekForAlCoaching"
                />
              </div>
            </div>
          </div>

          <div class="element-box mb-3 mt-4">
            <h6 class="mt-3">
              Geleistete Einheiten im Monat
            </h6>

            <div class="row mt-4">
              <div class="col-lg-3 col-md-4 col-sm-12">
                <SelectVue
                    v-model="filters.coachingType"
                    :options="dropdownCoachingType"
                    :is-clear="false"
                />
              </div>
              <div class="col-lg-2 col-md-4 col-sm-12">
                <SelectVue
                    v-model="filters.year"
                    placeholder="Standort"
                    :options="dropdownYears"
                    :is-clear="true"
                />
              </div>
              <div class="col-lg-4 col-md-4 col-sm-12">
                <SelectVue
                    v-model="filters.locationId"
                    placeholder="Standort"
                    :options="dropdownOffices"
                    :is-clear="true"
                />
              </div>

              <div class="col-auto text-center">
                <button class="btn btn-primary custom_search_button2" @click="getChartBarArea()">
                      <span v-if="isSearching">
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                        {{ $t('general.button.search_in_progress') }}
                      </span>
                  <span v-else>
                        {{ $t('general.button.search') }}
                      </span>
                </button>
              </div>
            </div>
            <VueApexCharts width="100%" height="450" type="bar" :options="chartOptionsBar" :series="seriesSignBar"/>
          </div>
        </div>
      </div>
      <FormSidebar>
        <template #top>
          <h6 class="element-header">
            Sidebar Infos
          </h6>
        </template>

        <div class="element-box pie mt-2">
          <h6>{{ $t('general.active_customers') }}</h6>
          <VueApexCharts
              :key="seriesActiveCoach.length"
              width="100%"
              type="donut"
              :options="chartOptions"
              :series="seriesActiveCoach"/>
        </div>

        <div class="element-box pie mt-2">
          <h6>{{ $t('general.new_customers') }}</h6>
          <VueApexCharts
              :key="seriesNewCoach.length"
              width="100%"
              type="donut"
              :options="chartOptionsNewCoach"
              :series="seriesNewCoach"/>
        </div>

      </FormSidebar>
    </div>
  </div>
</template>

<script setup>
import dashboardHeadPsychosocialServicesService from '@/api/Dashboard/HeadPsychosocialServices';
import CoachingButton from '@/components/button/CoachingButton.vue';
import CoachingCardInfo from '@/components/card/CoachingCardInfo.vue';
import FormSidebar from '@/components/FormSidebar.vue';
import SelectVue from '@/components/SelectVue.vue';
import { ErrorToast } from '@/components/VueToast';
import { getCoachingTypes, getOfficeDropdown, getYears } from '@/shared/dropdowns';
import { getDonutColorsByCompany, optionsChartBar, optionsChartDonut } from '@/shared/utils/apex';
import { MonthsUtils } from '@/shared/utils/MonthsUtils';
import { piniaCompanySettingsStore } from '@/store/piniaCompanySettingsStore';
import { piniaUserStore } from '@/store/piniaUserStore';
import Menu from '@/views/App/Dashboard/HeadPsychosocialServices/Menu.vue';
import { computed, onMounted, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import VueApexCharts from 'vue3-apexcharts';

const { t }                = useI18n();
const dropdownYears        = ref([]);
const dropdownCoachingType = ref([]);
const dropdownOffices      = ref([]);

const piniaCompanySettingsState = piniaCompanySettingsStore();
const companySettings = computed(() => piniaCompanySettingsState.companySettings);

const dashboardData = ref({});

const seriesActiveCoach = ref([]);
const seriesNewCoach    = ref([]);
const seriesSignBar     = ref([]);
const isSearching       = ref(false);

const chartOptions         = ref(optionsChartDonut);
const chartOptionsNewCoach = ref(optionsChartDonut);

const chartOptionsBar = ref({
  ...optionsChartBar,
  yaxis: {
    min: 0,
    max: 1000 + 10,
    forceNiceScale: true,
  },
  xaxis: {
    categories: MonthsUtils(t),
  },
  colors: [
    'rgba(67, 173, 78, 0.6)',
    'rgba(75, 192, 192, 0.6)',
  ],
  plotOptions: {
    bar: {
      distributed: false,
    },
  },
});

const filters = ref({
  coachingType: 'socio_therapy_coaching',
  year: new Date().getFullYear(),
  locationId: '',
});

function buildSeries(counts) {
  return [
    counts?.socioTherapyCoaching ?? 0,
    counts?.assistedLivingCoaching ?? 0,
  ];
}

function buildDonutOptions(options, series) {
  const total = series.reduce((sum, value) => sum + value, 0);

  return {
    ...options,
    colors: getDonutColorsByCompany(companySettings.value?.companyKey),
    responsive: [ {
      breakpoint: 2480,
      options: {
        chart: {
          width: '100%',
          height: 300,
        },
        legend: {
          position: 'bottom',
        },
      },
    } ],
    labels: [
      `Soziotherapie ${series[0]}`,
      `Betreutes Wohnen ${series[1]}`,
    ],

    legend: {
      show: true,
      position: 'bottom',
      horizontalAlign: 'left',
      fontSize: '11px',
      fontFamily: 'Inter, sans-serif',
      fontWeight: 400,
      textColor: '#64748b',
      itemMargin: {
        horizontal: 6,
        vertical: 2
      },
      markers: {
        width: 8,
        height: 8,
        radius: 12,
        offsetX: -3
      }
    },

    plotOptions: {
      pie: {
        donut: {
          ...options.plotOptions.pie.donut,
          labels: {
            ...options.plotOptions.pie.donut.labels,
            total: {
              ...options.plotOptions.pie.donut.labels.total,
              formatter: () => total.toString(),
            },
          },
        },
      },
    },
  };
}

async function getInfoData() {
  try {
    const { data } = await dashboardHeadPsychosocialServicesService.getInfoData();

    dashboardData.value = data.data;

    const activeSeries = buildSeries(data.data.countActiveCoaching?.counts);
    const newSeries    = buildSeries(data.data.countNewCoaching?.counts);

    seriesActiveCoach.value    = activeSeries;
    seriesNewCoach.value       = newSeries;
    chartOptions.value         = buildDonutOptions(chartOptions.value, activeSeries);
    chartOptionsNewCoach.value = buildDonutOptions(chartOptionsNewCoach.value, newSeries);
  } catch (error) {
    await ErrorToast(error);
  }
}

async function getChartBarArea() {
  try {
    isSearching.value = true;

    const { data } =
        await dashboardHeadPsychosocialServicesService.getUnitsDoneChart(filters.value);

    seriesSignBar.value = [
      data.data.chartData.signedUnits,
      data.data.chartData.unsignedUnits,
    ];

    const allValues = [
      ...data.data.chartData.signedUnits.data,
      ...data.data.chartData.unsignedUnits.data,
    ];

    const maxValue = Math.max(...allValues);

    const niceMax = Math.ceil(maxValue / 10) * 10;

    chartOptionsBar.value = {
      ...chartOptionsBar.value,
      chart: {
        ...chartOptionsBar.value.chart,
        height: 450,
      },
      yaxis: {
        min: 0,
        max: niceMax,
        tickAmount: 5,
      },
    };

    isSearching.value = false;
  } catch (error) {
    isSearching.value = false;
    await ErrorToast(error);
  }
}

onMounted(() => {
  getInfoData();
  getChartBarArea();
  getYears(dropdownYears);
  getCoachingTypes(dropdownCoachingType, [
    'group_coaching',
    'private_learning_coaching',
    'job_coaching',
    'occupational_therapy_coaching',
    'private_coaching',
    'case_management_coaching',
  ]);
  getOfficeDropdown(dropdownOffices);
});

</script>

<style scoped>
::v-deep(.pie .apexcharts-legend) {
  display: block !important;
}
</style>